import { useMutation } from '@tanstack/react-query';
import { useSearch } from '@tanstack/react-router';
import { AGGREGATE_NAMES, LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { APICommunicator } from '~/api/APICommunicator.ts';
import { setQueryPosition } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys.ts';

type Props = {
    aggregateId: string;
    offerId: string;
    documentKey?: string;
};

export const useDeleteOffer = ({ aggregateId, documentKey, offerId }: Props) => {
    const search = useSearch({ strict: false });
    const offerFilter = 'offerFilter' in search ? search.offerFilter : {};
    const { t } = useTranslation();
    const queryKey = queryKeys.getAcceptedOffers(aggregateId, offerFilter);

    return useMutation({
        mutationFn: async () => {
            return APICommunicator.sendCommand({
                aggregateId,
                aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
                commandName: LOAN_REQUEST_COMMANDS.deleteManualOffer,
                payload: { documentKey, id: offerId },
            });
        },
        onError: () => {
            toast.error(t('OFFER_MANAGEMENT.OFFER_DELETED_ERROR'));
        },
        onSuccess: async () => {
            await new Promise((resolve) => {
                setTimeout(resolve, 500);
            });
            setQueryPosition(JSON.stringify(queryKey), 0);
        },
    });
};
